import React from 'react'

export default function Loading() {
  return <div role="status">Loading...</div>
}
